import React, { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { PageWrapper } from "../../components/blocks";
import  Button from "../../components/atoms/button";
import { SiteContext } from "../../context/SiteContext";
import { getLogoURL } from "../../utils/general";
import { useNavigate } from "react-router-dom";
import {RouletteOutline} from "../../assets/icon/roulette";

const RouletteList = () => {
  const { sala, salaId } = useContext(SiteContext);
  const navigate = useNavigate();

  const {
    data: rouletteList,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["get_roulette_list"],
    queryFn: async () => {
      const config = {
        headers: {
          'X-Sala-ID': salaId
        }
      };
      const res = await axios.get("https://api5.wargos.cloud/xsorteos/roulette", config);
      return res.data;
    },
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error loading roulette list</div>;
  }

  const goBack = () => {
    navigate("/selector");
  };

  const handleRouletteClick = (rouletteId) => {
    navigate(`/juego-ruleta/${rouletteId}`);
  };

  return (
    <PageWrapper>
      <div className="flex flex-col items-center w-full gap-6 p-6">
        <div
          onClick={() => goBack()}
          className="flex items-center justify-center transition-all cursor-pointer hover:scale-[95%]"
        >
          {sala ? (
            <img className="w-auto max-h-[80px]" src={getLogoURL(sala.logo)} alt="logo" />
          ) : (
            <div className="h-[80px] w-[200px] bg-white/50 animate-pulse" />
          )}
        </div>
        <div className="grid w-full max-w-screen-xl grid-cols-1 gap-10 text-center transition-all md:grid-cols-2 lg:grid-cols-3">
          {rouletteList.map((roulette) => (
            <Button
              key={roulette.id}
              onClick={() => handleRouletteClick(roulette.id)}
              className="w-full py-10"
              variant="primary"
            >
              <div className="flex flex-col items-center gap-6">
                <span className="text-4xl font-black uppercase">{roulette.name}</span>
                <RouletteOutline size={150} />
                <span className="text-2xl font-bold uppercase">{roulette.prizes.length} Premios</span>
              </div>
            </Button>
          ))}
        </div>
      </div>
    </PageWrapper>
  );
};

export default RouletteList;
